import React from 'react';
import Card from './Card';
import Card2 from './card2.png';
import Card3 from './card3.png';
import Card4 from './card4.png';
import Card5 from './card5.png';
import Card6 from './card6.png';
import Card7 from './card7.png';
import Card8 from './card8.png';
import Card9 from './card9.png';
import Card1 from './card.1.png';



const Services = () => {
    return (
        <>
       
        <div className='container my-3 text-center'>

            

         
            <div className='row'>
                <h1 style={{color:'WindowFrame'}}>Our_Services</h1>
                <div className='col-md-4'>
                    <Card imgCard={Card1} Cardname="Life insurance is a contract between an insurance policy holder and an insurer or assurer, where the insurer promises to pay a designated beneficiary a sum of money in exchange for a premium, upon the death of an insured person." Cardtittle="LIFE INSURANCE" Read="Buy now" />
                    <Card imgCard={Card2} Cardname="Health insurance is an insurance that covers the whole or a part of the risk of a person incurring medical expenses, spreading the risk over a large number of persons." Cardtittle="HEALTH INSURANCE" Read="Buy now"/>
                    <Card imgCard={Card3} Cardname="Vehicle insurance is insurance for award, trucks, motorcycles, and other road vehicles. Its primary use is to provide financial protection against physical damage or bodily injury resulting from traffic collisions and against liability that could also arise from incidents in a vehicle." Cardtittle="MOTOR INSURANCE" Read="Buy now"/>

                </div>
                <div className='col-md-4'>
                    <Card imgCard={Card4} Cardname="Travel insurance is insurance that is intended to cover medical expenses, trip cancellation, lost luggage, flight accident and other losses incurred while traveling, either internationally or domestically." Cardtittle="TRAVEL INSURANCE" Read="Buy now"/>
                    <Card imgCard={Card5} Cardname="Personal Accident insurance or PA insurance is an annual policy which provides compensation in the event of injuries, disability or death caused solely by violent, accidental, external and visible events. " Cardtittle="PERSONAL ACCIDENT INSURANCE" Read="Buy now"/>
                    <Card imgCard={Card6} Cardname="Bond insurance, also known as “financial guaranty insurance,” is a type of insurance whereby an insurance company guarantees scheduled payments of interest and principal on a bond or other security _______" Cardtittle="BOND" Read="Buy now"/>

                </div>
                <div className='col-md-4'>
                    <Card imgCard={Card7} Cardname="A fixed deposit is a financial instrument provided by banks or NBFCs which provides investors a higher rate of interest than a regular savings account, until the given maturity date. It may or may not require the creation of a separate account." Cardtittle="FIXED DEPOSITS" Read="Buy now"/>
                    <Card imgCard={Card8} Cardname="A home loan deposit is your initial contribution to the purchase price of a property. It means that you own a small portion of the home.Some will accept lower deposits but you may have to pay Lenders Mortgage Insurance." Cardtittle="HOME LOANS" Read="Buy now"/>
                    <Card imgCard={Card9} Cardname="A mutual fund is a professionally managed investment fund that pools money from many investors to purchase securities. These investors may be retail or institutional in nature and it manages professionally" Cardtittle="MUTUAL FUNDS" Read="Buy now"/>

                </div>
                



            </div>
            
        </div>
        
        </>
        
    );
}

export default Services;
